import lottie from 'lottie-web';

// const isHub = !$('.section-hero').length;
// const jsonPath = isHub ? '' : '../';
const jsonPath = '';
// const srcLottieSplashScreenOne = jsonPath + 'json/Flower-1.json';
const srcLottieSplashScreenOne = jsonPath + 'json/Flower-1-remap.json';
const srcLottieSplashScreenTwo = jsonPath + 'json/Flower-2-remap.json';
const srcLottieAisleOne = jsonPath + 'json/Flower-Culinary-L-remap.json';
const srcLottieAisleTwo = jsonPath + 'json/Flower-SHC-remap.json';
const srcLottieCulinaryOne = jsonPath + 'json/Flower-Culinary-L-remap.json';
const srcLottieCulinaryTwo = jsonPath + 'json/Flower-Culinary-R-remap.json';
const srcLottieDta = jsonPath + 'json/premium/PE-2-Light.json';
const srcBusinsessSeat = jsonPath + 'json/business/BC-4.json';
const srcMessage = jsonPath + 'json/message/messages-15jan.json';
const srcLady = jsonPath + 'json/LightonLady/BC-2-Light.json';
const srcPremiumEconomySeat6Selfie = jsonPath + 'json/PremiumEconomySeat6Selfie/PE-6-Selfie.json';
// const srcLottieAisleThree = jsonPath + 'json/Flower-Culinary-L-remap.json';

// function lottieSplashScreen(callback) {
// 	// Function to load a Lottie animation and return a Promise
// 	function loadLottieAnimation(el, src) {
// 		return new Promise((resolve, reject) => {
// 			const animation = lottie.loadAnimation({
// 				container: el,
// 				renderer: 'svg',
// 				loop: false,
// 				duration: 1,
// 				autoplay: false,
// 				path: src,
// 			});

// 			// Resolve the promise once the animation is loaded
// 			animation.addEventListener('DOMLoaded', () => {
// 				resolve(animation);
// 			});

// 			// Optionally, reject the promise on loading error
// 			animation.addEventListener('error', (e) => {
// 				reject(e);
// 			});
// 		});
// 	}

// 	const $lottieSplashScreenOne = document.querySelector('[data-lottie-splash-screen-one]');
// 	const $lottieSplashScreenTwo = document.querySelector('[data-lottie-splash-screen-two]');

// 	// Load both animations and run your function afterwards
// 	Promise.all([
// 		loadLottieAnimation($lottieSplashScreenOne, srcLottieSplashScreenOne),
// 		loadLottieAnimation($lottieSplashScreenTwo, srcLottieSplashScreenTwo),
// 	])
// 		.then((animations) => {
// 			// animations[0].play();
// 			// animations[1].play();
// 			callback();
// 		})
// 		.catch((error) => {
// 			console.error('Error loading an animation:', error);
// 		});
// }

function lottieSplashScreen() {
	function lottieInitFlower(el, src) {
		return lottie.loadAnimation({
			container: el,
			renderer: 'svg',
			loop: false,
			duration: 1,
			autoplay: false,
			path: src,
		});
	}

	const $lottieSplashScreenOne = document.querySelector('[data-lottie-splash-screen-one]');
	const $lottieSplashScreenTwo = document.querySelector('[data-lottie-splash-screen-two]');

	const animationOne = lottieInitFlower($lottieSplashScreenOne, srcLottieSplashScreenOne);
	const animationTwo = lottieInitFlower($lottieSplashScreenTwo, srcLottieSplashScreenTwo);

	return () => {
		animationOne.play();
		animationTwo.play();
	};
}

function lottieAisle() {
	function lottieAislFlower(el, src) {
		return lottie.loadAnimation({
			container: el,
			renderer: 'svg',
			loop: false,
			duration: 1,
			autoplay: false,
			path: src,
		});
	}

	const $lottieAisleOne = document.querySelector('[data-lottie-aisle-one]');

	const $lottieAisleTwo = document.querySelector('[data-lottie-aisle-two]');

	const animationOneAisle = lottieAislFlower($lottieAisleOne, srcLottieAisleOne);
	const animationTwoAisle = lottieAislFlower($lottieAisleTwo, srcLottieAisleTwo);

	return {
		animationOneAisle,
		animationTwoAisle,
	};
}

function lottieCulinary() {
	function lottieCulinaryFlower(el, src) {
		return lottie.loadAnimation({
			container: el,
			renderer: 'svg',
			loop: false,
			duration: 1,
			autoplay: false,
			path: src,
		});
	}

	const $lottieCulinaryOne = document.querySelector('[data-lottie-culinary-one]');

	const $lottieCulinaryTwo = document.querySelector('[data-lottie-culinary-two]');

	const animationCulinaryOne = lottieCulinaryFlower($lottieCulinaryOne, srcLottieCulinaryOne);
	const animationCulinaryTwo = lottieCulinaryFlower($lottieCulinaryTwo, srcLottieCulinaryTwo);

	return {
		animationCulinaryOne,
		animationCulinaryTwo,
	};
}

function lottieDta() {
	function lottieDtaFlower(el, src) {
		return lottie.loadAnimation({
			container: el,
			renderer: 'svg',
			loop: false,
			duration: 1,
			autoplay: false,
			path: src,
		});
	}

	const $lottieDtaOne = document.querySelector('[data-lottie-restart-dta-one]');

	const animationDta = lottieDtaFlower($lottieDtaOne, srcLottieDta);

	return {
		animationDta,
	};
}

function initAisleLotties() {
	function lottieStInit(el, src) {
		return lottie.loadAnimation({
			container: el,
			renderer: 'svg',
			loop: true,
			duration: 1,
			autoplay: true,
			path: src,
		});
	}

	const $lottieStPic = document.querySelectorAll('[data-lottie-st]');

	$lottieStPic.forEach((el) => {
		const srcLottie = el.dataset.lottieSt;
		lottieStInit(el, srcLottie);
	});
}

function initBusinessSeat() {
	//console.log('initBusinessSeat');

	function lottieInit(el, src) {
		//console.log('initBusinessSeat', el, src);
		return lottie.loadAnimation({
			container: el,
			renderer: 'svg',
			loop: true,
			duration: 1,
			autoplay: true,
			path: src,
		});
	}

	const container = document.querySelector('[data-lottie-seat]');

	return lottieInit(container, srcBusinsessSeat);
}

export { lottieSplashScreen, lottieAisle, lottieDta, lottieCulinary, initAisleLotties, initBusinessSeat };
